<script setup>
import { onMounted, ref } from 'vue';
import card_header from '@/components/card_header.vue';
import { useRoute } from 'vue-router';
import { create_ticket } from '@/services/tickets';
import { swalError, swalSuccess } from '@/helper';
import { get_option } from '@/services/packages';

const questionaire = ref([])

const form = ref({})
const route = useRoute()
const isLoading = ref(true)
onMounted(async()=>{
  form.value.child_name = route.query.child
  form.value.trait_name = route.query.trait
  await get_feedback_question()
  isLoading.value = false
})

async function get_feedback_question(){
  let response = await get_option('feedback_question')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result){
    questionaire.value = parseQuestion(response.result)
  }
}

function parseQuestion(result){
  let temp = result.included.map(item => {
    return {
      id: item.id,
      title: item.attributes.key,
      type: item.attributes.value,
    }
  })
  return temp
}

const isSubmit = ref(false)
async function submitForm(){
  isSubmit.value = true
  let formMeta = questionParams()
  formMeta = {
    questions: {...formMeta},
    child_name: form.value.child_name,
    child_id: route.query.id,
    trait_name: form.value.trait_name
  }
  console.log("🚀 ~ submitForm ~ formMeta:", formMeta)
  let params = {}
  params.ticket_type = 'feedback'
  params.topic = route.query.trait + ' - ' + route.query.age_group
  let userData = JSON.parse(localStorage.getItem('user_data'))
  params.subject = capitalizeWords(`${userData.first_name} ${userData.last_name}`) + ' - ' + form.value.child_name
  params.meta = JSON.stringify(formMeta)
  let response = await create_ticket(params)
  if(response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Form has been submitted')
  document.getElementById('feedback_form').reset()
  isSubmit.value = false
}

function questionParams(){
  console.log(form.value)
  const formData = new FormData(feedback_form);
  const formObj = []

  for (const [key, value] of formData) {
    let {title} = questionaire.value.find(item => item.id == key)
    formObj.push({title, answer: value})
  }
  return formObj
}

function capitalizeWords(str) {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Intervention Feedback Form"/>
    <div class="card">
      <card_header title="Intervention Feedback Form"/>
      <div class="card-body">
        <form @submit.prevent="submitForm" id="feedback_form">
          <div class="row mb-3">
            <div class="col-8">
              <label class="form-label">Full Name</label>
              <input class="form-control" type="text"
                placeholder="Child name"
                required
                v-model="form.child_name"
                name="child_name"
                disabled
              >
            </div>
            <div class="col-4">
              <label class="form-label" >Trait Name</label>
              <input class="form-control" type="text"
                placeholder="Trait name"
                required
                name="trait_name"
                v-model="form.trait_name"
                disabled
              >
            </div>
          </div>
          <div class="row mb-3">
            <div v-for="question in questionaire" :key="question.id" class="col-12 mb-3">
              <label class="form-label">
                {{ question.title }}
              </label>

              <template v-if="question.type == 'choice'">
                <div class="d-flex">
                  <label class="d-flex align-items-center me-2">
                    <input type="radio" :name="question.id" value="yes" required>
                    <span class="ms-1 my-auto">Yes</span>
                  </label>
                  <label class="d-flex align-items-center me-2">
                    <input type="radio" :name="question.id" value="no"  required>
                    <span class="ms-1 my-auto">No</span>
                  </label>
                </div>
              </template>
              <template v-if="question.type == 'input'">
                <div class="col">
                  <input class="form-control" type="text"
                    placeholder="Text input"
                    required
                    value=""
                    :name="question.id"
                  >
                </div>
              </template>
            </div>
          </div>

          <div>
            <button type="submit" class="btn btn-light-success">
              <span v-if="!isSubmit">Submit</span>
              <span v-else>
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>